import Vue from "vue";
import Vuex from "vuex";
import utils from "@/utils/index.js";
import moduleUser from "./modules/user.js";
import moduleSession from "./modules/session.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    homeURL: location.origin,
    signInURL: "",
    signInDialogVisible: false,
    qrCodeVisible: true,
    weChatTipVisible: false,
    customerServiceDialogVisible: false,
  },
  getters: {},
  mutations: {
    setSignInURL(state, signInURL) {
      state.signInURL = signInURL;
    },
    setSignInDialogVisible(state, signInDialogVisible) {
      state.signInDialogVisible = signInDialogVisible;
    },
    setQrCodeVisible(state, qrCodeVisible) {
      state.qrCodeVisible = qrCodeVisible;
    },
    setWeChatTipVisible(state, weChatTipVisible) {
      state.weChatTipVisible = weChatTipVisible;
    },
    setCustomerServiceDialogVisible(state, customerServiceDialogVisible) {
      state.customerServiceDialogVisible = customerServiceDialogVisible;
    },
  },
  actions: {
    openSignInDialog({ commit, state }) {
      const qrCodeVisible = !utils.isMobileDevice() && !utils.isWeiXin();
      const weChatTipVisible = utils.isMobileDevice() && !utils.isWeiXin();
      commit("setQrCodeVisible", qrCodeVisible);
      commit("setWeChatTipVisible", weChatTipVisible);
      if (utils.isWeiXin()) {
        location.href = state.signInURL;
        return;
      }
      commit("setSignInDialogVisible", true);
    },
  },
  modules: {
    user: moduleUser,
    session: moduleSession,
  },
});
